import { NString, ServiceCatalogueApiSettings } from "@core/models";
import { Logger } from "../Logger";

declare global {
    var Fluids365SDKDataAccess: any;
    var FluidsSdk: any;
}
type CustomEndpoints = {
    RequestOfferingQuery?: string;
    SubmitRequestOffering?: string;
}
type FluidsWidgetOptions = {
    endpoints?: CustomEndpoints;
}
export function initSDK(token: NString, config: ServiceCatalogueApiSettings, options?: FluidsWidgetOptions) {
    const data = String.isNotEmpty(token) ? {
        access_token: token,
        token_type: "Bearer",
        authToken: token
    } : null;

    const { Fluids365, ServiceManagement } = config.configurations;
    Logger.log("Initializing Fluids SDK...", options, ServiceManagement);

    FluidsSdk.Fluids365.connectorConfig = {
        ...Fluids365,
        connect(res: any) {
            res.send({ status: "success", data });
        }
    };
    FluidsSdk.ServiceManagement.connectorConfig = {
        ...ServiceManagement,
        connect(res: any) {
            res.send({ status: "success", data });
        }
    };
    FluidsSdk.ServiceManagement.apis = {
        ...FluidsSdk.ServiceManagement.apis,
        // ...endpoints,
        ...options?.endpoints,
        // SubmitRequestOffering: customEndpoints?.SubmitRequestOffering ||
        //     endpoints?.Submit ||
        //     FluidsSdk.ServiceManagement.apis.SubmitRequestOffering ||
        //     FluidsSdk.ServiceManagement.apis.Submit, 
        SubmitRequestOffering:
            options?.endpoints?.SubmitRequestOffering ||
            config.endpoints?.Submit ||
            FluidsSdk.ServiceManagement.apis.SubmitRequestOffering ||
            FluidsSdk.ServiceManagement.apis.Submit,
    };

    Fluids365SDKDataAccess.RegisterConnector("oms", {
        ...ServiceManagement,
        connect(res: any) {
            res.send({ status: "success", ...data });
        }
    });
} 